export default "__VITE_ASSET__D5eQiSav__"